"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EAvatarVariant = exports.EButtonVariants = exports.DialogVariant = exports.Surface = void 0;
/**
 * @internal
 */
var Surface;
(function (Surface) {
    Surface["base"] = "base";
    Surface["raised"] = "raised";
})(Surface = exports.Surface || (exports.Surface = {}));
/**
 * @internal
 */
var DialogVariant;
(function (DialogVariant) {
    DialogVariant["normal"] = "normal";
    DialogVariant["sidebar"] = "sidebar";
})(DialogVariant = exports.DialogVariant || (exports.DialogVariant = {}));
/**
 * The stylistic variants available to the buttons used by these components.
 * @public
 */
var EButtonVariants;
(function (EButtonVariants) {
    EButtonVariants["default"] = "default";
    EButtonVariants["primary"] = "primary";
    EButtonVariants["tinted"] = "tinted";
    EButtonVariants["text"] = "text";
})(EButtonVariants = exports.EButtonVariants || (exports.EButtonVariants = {}));
/**
 * The stylistic variants available to the avatars used by these components.
 * @public
 */
var EAvatarVariant;
(function (EAvatarVariant) {
    EAvatarVariant["human"] = "human";
    EAvatarVariant["entity"] = "entity";
    EAvatarVariant["bot"] = "bot";
})(EAvatarVariant = exports.EAvatarVariant || (exports.EAvatarVariant = {}));
//# sourceMappingURL=types.js.map